import { FC } from 'react';
import styles from '#components/common/teaser-meta/EpisodeInfos.module.scss';
import classNames from 'classnames';
import { Media } from '#types/generated/graphql-types';
import useTranslation from 'next-translate/useTranslation';

type Props = {
  data: Media;
  highlight?: boolean;
  hideSeasonInfo?: boolean;
};

const EpisodeInfos: FC<Props> = ({
  data,
  highlight = true,
  hideSeasonInfo = false,
}) => {
  const { t } = useTranslation();

  const className = classNames(styles.host, {
    [styles.highlight]: highlight,
  });

  if (!data?.season?.seasonNumber && !data?.episodeNumber) return null;

  return (
    <span className={className}>
      {data?.season?.seasonNumber && !hideSeasonInfo && (
        <span className={styles.part} aria-label={t('season', { count: 1 })}>
          {t('seasonShorthand')}
          {data.season.seasonNumber}
        </span>
      )}
      {data.episodeNumber && (
        <span className={styles.part} aria-label={t('episode')}>
          {t('episodeShorthand')}
          {data.episodeNumber}
        </span>
      )}
    </span>
  );
};

export default EpisodeInfos;
